import { Routes, Route } from "react-router-dom";
import React, { lazy, Suspense } from "react";

const Home = lazy(() => import("./components/Home"));
const About = lazy(() => import("./components/About"));
const Services = lazy(() => import("./components/Services"));
const Media = lazy(() => import("./components/Media"));
const Contact = lazy(() => import("./components/Contact"));
const ServiceDetails = lazy(() => import("./components/ServiceDetails"));
const NewsView = lazy(() => import("./components/NewsView"));
const Policies = lazy(() => import("./components/Policies"));
const Terms = lazy(() => import("./components/Terms"));
const Team = lazy(() => import("./components/Team"));
// const ErrorPage = lazy(() => import("./components/ErrorPage"));

function App() {
  return (
    <div>
      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center vh-100">
            <img src="assets/images/gallery/loadings.gif" alt="logo loading" />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/discover" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/media" element={<Media />} />
          <Route path="/contactus" element={<Contact />} />
          <Route path="/:title" element={<ServiceDetails />} />
          <Route path="/newsview" element={<NewsView />} />
          <Route path="/termsandconditions" element={<Terms />} />
          <Route path="/ourteam" element={<Team />} />
          <Route path="/privacypolicy" element={<Policies />} />
          {/* <Route path="*" element={<ErrorPage />} /> */}
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
